module.exports = __webpack_public_path__ + "static/media/quiz-menina.fb23acd2.png";